import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74ed4bb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "data-cy": "content-block"
}
const _hoisted_2 = ["data-cy"]
const _hoisted_3 = { class: "grid grid-row-4 grid-flow-col gap-1" }
const _hoisted_4 = { class: "py-1 svg-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_information_circle_icon = _resolveComponent("information-circle-icon")!
  const _component_html_textarea = _resolveComponent("html-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.numberOfItems)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (block, url, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: url,
              class: "pt-6 base-element"
            }, [
              (_openBlock(), _createElementBlock("div", {
                class: "border-l-4 border-teal-500 px-4 py-3 shadow-md block-container",
                key: url + '-' + index,
                role: "alert",
                "data-cy": 'content-block-child-' + index
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_information_circle_icon, { class: "h-9 w-8 mr-4 svg-ico" })
                  ]),
                  _createVNode(_component_html_textarea, {
                    value: block,
                    class: "w-full self-center",
                    "data-cy": "input"
                  }, null, 8, ["value"])
                ])
              ], 8, _hoisted_2))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_5
  ], 64))
}